/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMatchCompetencyQuestion } from '../fn/match-question/create-match-competency-question';
import { CreateMatchCompetencyQuestion$Params } from '../fn/match-question/create-match-competency-question';
import { deleteMatchQuestion } from '../fn/match-question/delete-match-question';
import { DeleteMatchQuestion$Params } from '../fn/match-question/delete-match-question';
import { getMatchQuestion } from '../fn/match-question/get-match-question';
import { GetMatchQuestion$Params } from '../fn/match-question/get-match-question';
import { getMatchQuestions } from '../fn/match-question/get-match-questions';
import { GetMatchQuestions$Params } from '../fn/match-question/get-match-questions';
import { MatchQuestion } from '../models/match-question';
import { MatchQuestionPagedData } from '../models/match-question-paged-data';
import { updateMatchQuestion } from '../fn/match-question/update-match-question';
import { UpdateMatchQuestion$Params } from '../fn/match-question/update-match-question';

@Injectable({ providedIn: 'root' })
export class MatchQuestionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMatchQuestions()` */
  static readonly GetMatchQuestionsPath = '/matchquestion';

  /**
   * Gets all matching questions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMatchQuestions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchQuestions$Response(params?: GetMatchQuestions$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestionPagedData>> {
    const obs = getMatchQuestions(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all matching questions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMatchQuestions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchQuestions(params?: GetMatchQuestions$Params, context?: HttpContext): Observable<MatchQuestionPagedData> {
    const resp = this.getMatchQuestions$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchQuestionPagedData>): MatchQuestionPagedData => r.body)
    );
  }

  /** Path part for operation `createMatchCompetencyQuestion()` */
  static readonly CreateMatchCompetencyQuestionPath = '/matchquestion';

  /**
   * Creates a new matching question [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMatchCompetencyQuestion()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMatchCompetencyQuestion$Response(params?: CreateMatchCompetencyQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestion>> {
    const obs = createMatchCompetencyQuestion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new matching question [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMatchCompetencyQuestion$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMatchCompetencyQuestion(params?: CreateMatchCompetencyQuestion$Params, context?: HttpContext): Observable<MatchQuestion> {
    const resp = this.createMatchCompetencyQuestion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchQuestion>): MatchQuestion => r.body)
    );
  }

  /** Path part for operation `getMatchQuestion()` */
  static readonly GetMatchQuestionPath = '/matchquestion/{id}';

  /**
   * Gets the specified matching question.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMatchQuestion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchQuestion$Response(params: GetMatchQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestion>> {
    const obs = getMatchQuestion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified matching question.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMatchQuestion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchQuestion(params: GetMatchQuestion$Params, context?: HttpContext): Observable<MatchQuestion> {
    const resp = this.getMatchQuestion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchQuestion>): MatchQuestion => r.body)
    );
  }

  /** Path part for operation `updateMatchQuestion()` */
  static readonly UpdateMatchQuestionPath = '/matchquestion/{id}';

  /**
   * Updates the specified matching question [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMatchQuestion()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMatchQuestion$Response(params: UpdateMatchQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestion>> {
    const obs = updateMatchQuestion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified matching question [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMatchQuestion$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMatchQuestion(params: UpdateMatchQuestion$Params, context?: HttpContext): Observable<MatchQuestion> {
    const resp = this.updateMatchQuestion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchQuestion>): MatchQuestion => r.body)
    );
  }

  /** Path part for operation `deleteMatchQuestion()` */
  static readonly DeleteMatchQuestionPath = '/matchquestion/{id}';

  /**
   * Deletes the specified matching question [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMatchQuestion()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMatchQuestion$Response(params: DeleteMatchQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteMatchQuestion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified matching question [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMatchQuestion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMatchQuestion(params: DeleteMatchQuestion$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteMatchQuestion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
